export function IsPC() {
	let userAgentInfo = navigator.userAgent;
	let Agents = [
		"Android",
		"iPhone",
		/*"SymbianOS",
		"Windows Phone",
		"iPad",
		"iPod"*/
	];

	let flag = true;
	for (let v = 0; v < Agents.length; v++) {
		if (userAgentInfo.indexOf(Agents[v]) > 0) {
			flag = false;
			break;
		}
	}

	return flag; // true为PC端，false为手机端
}

export function resize() {
	let deviceWidth = document.documentElement.clientWidth;

	if( IsPC() ) {
		document.documentElement.style.fontSize = '14px';
	}else {
		if(deviceWidth > 828) {
			deviceWidth = 8.28 * 50;
		}
		document.documentElement.style.fontSize = deviceWidth / 8.28 + 'px';
	}
}